import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
import { ShieldCheck } from 'lucide-react';
import { trackAddToCart } from '../../hooks/useMetaPixel';
export function FAQAndPricing() {
  const faqs = [{
    q: '¿Es seguro?',
    a: 'Sí, se basa en ingredientes naturales y masajes suaves sobre la piel. No utilizamos pastillas ni químicos agresivos.'
  }, {
    q: '¿Tendré que ir al baño mucho?',
    a: 'Notarás un aumento en la frecuencia para orinar, que es exactamente como el cuerpo expulsa el líquido drenado de forma natural.'
  }, {
    q: '¿Puedo hacerlo si trabajo?',
    a: 'Absolutamente, el plan de comidas y las infusiones son fáciles de preparar y llevar a la oficina en un termo.'
  }, {
    q: '¿Necesito equipo especial?',
    a: 'Ninguno, solo tus manos para los masajes y un par de ingredientes básicos que encuentras en cualquier supermercado local.'
  }];
  return <section className="py-20 px-4 bg-white" data-id="element-29">
      <div className="max-w-4xl mx-auto" data-id="element-30">
        {/* Proof Section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-sage-300/20 rounded-3xl p-8 md:p-12 mb-20 text-center" data-id="element-31">
          <h2 className="text-3xl font-bold font-playfair mb-6" data-id="element-32">
            Lo que cambia en 48 horas
          </h2>
          <p className="text-lg text-forest/80 leading-relaxed max-w-2xl mx-auto" data-id="element-33">
            El sistema linfático es el sistema de alcantarillado de tu cuerpo.
            Al activarlo manualmente y bajar la señal de estrés, el cuerpo puede
            eliminar{' '}
            <strong className="text-forest" data-id="element-34">
              hasta 2 litros de exceso de líquido retenido
            </strong>{' '}
            en el área abdominal en menos de dos días, reduciendo visualmente{' '}
            <strong className="text-forest" data-id="element-35">
              entre 2 y 5 centímetros de contorno
            </strong>
            .
          </p>
        </motion.div>

        {/* FAQ */}
        <div className="mb-20" data-id="element-36">
          <h2 className="text-3xl font-bold font-playfair text-center mb-10" data-id="element-37">
            Preguntas Frecuentes
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-38">
            {faqs.map((faq, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} className="bg-cream-100/50 p-6 rounded-2xl" data-id="element-39">
                <h4 className="font-bold text-lg mb-2 text-forest" data-id="element-40">{faq.q}</h4>
                <p className="text-forest/70" data-id="element-41">{faq.a}</p>
              </motion.div>)}
          </div>
        </div>

        {/* Pricing Block */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-forest text-white rounded-[2.5rem] p-8 md:p-14 text-center relative overflow-hidden shadow-2xl" data-id="element-42">
          {/* Decorative blur */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-gold-500/10 blur-3xl rounded-full pointer-events-none" data-id="element-43"></div>

          <div className="relative z-10" data-id="element-44">
            <ShieldCheck className="w-12 h-12 text-gold-400 mx-auto mb-6" data-id="element-45" />
            <h2 className="text-3xl md:text-4xl font-bold font-playfair mb-6" data-id="element-46">
              Tu confianza no tiene precio
            </h2>
            <p className="text-lg text-cream-200/80 mb-8 max-w-2xl mx-auto" data-id="element-47">
              No necesitas pagar cientos de dólares por una sesión de masajes
              profesionales o suplementos costosos de última hora. Obtén el
              Protocolo Completo "Vientre Plano en 48h" y recupera tu figura hoy
              mismo por una fracción del costo.
            </p>

            <div className="mb-10" data-id="element-48">
              <div className="flex items-center justify-center gap-3 mb-2" data-id="element-49">
                <span className="text-2xl md:text-3xl text-cream-200/40 line-through" data-id="element-50">
                  $19.99
                </span>
                <span className="bg-gold-400 text-forest text-sm font-bold px-3 py-1 rounded-full" data-id="element-51">
                  -68%
                </span>
              </div>
              <span className="text-5xl md:text-6xl font-bold text-gold-400" data-id="element-52">
                $6.39
              </span>
              <span className="text-cream-200/60 ml-2" data-id="element-53">USD</span>
            </div>

            <Button className="w-full md:w-auto text-lg md:text-xl px-8 md:px-12 py-5 shadow-gold-500/20" onClick={() => {
            trackAddToCart();
            window.open('https://temptbeuty.com/cart/56832850591904:1', '_blank');
          }} data-id="element-54">
              ¡SÍ! QUIERO DESINFLAMAR MI VIENTRE AHORA
            </Button>

            <p className="text-sm text-cream-200/60 mt-6 flex items-center justify-center" data-id="element-55">
              <svg className="w-4 h-4 mr-2 text-sage-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-56">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" data-id="element-57" />
              </svg>
              Pago 100% seguro. Acceso digital inmediato.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}